import $ from 'jquery';

$(function () {

    function askForConfirm(event) {

        const $element = $(this);

        if (!confirm($element.data('alert'))) {
            event.preventDefault();
        }
    }

    $('body')
        .on('click', 'a.confirmed, button.confirmed', askForConfirm)
        .on('submit', 'form.confirmed', askForConfirm);

    $('form').on('submit', function (e) {

        var $form = $(this);

        if ($form.data('submitted')) {

            e.preventDefault();
        }

        setTimeout(function () {
            $form.find('button[type=submit]').each(function () {
                const $btn = $(this);

                if (!$btn.data('no-auto-disable')) {
                    $btn.prop('disabled', 'disabled');
                }
            });
        }, 0);
    });

});


const Cookies = require('js-cookie')

export default class Consent {
    constructor() {
        this.stickyGdpr = $('.gdpr-sticky')
        this.stickyGdprAccept = $('#gdpr-accept')
        this.modalGdprColumn = $('.modal__gdpr__column')
        this.modalGdprSave = $('#gdpr-save')
        this.modalGdprAcceptAll = $('#gdpr-accept-all')
        this.modalGdprContainer = $('#modal-gdpr-container')
        this.gdprVersion = '1.0' // modifying this will show consent sticky for everyone again
    }

    checkConsent() {
        const gdprConsentAccepted = Cookies.get('gdprConsentAccepted')
        const gdprConsentType = Cookies.get('gdprConsentType')
        const gdprConsentVersion = Cookies.get('gdprConsentVersion')

        if (gdprConsentAccepted == 0 || !gdprConsentAccepted || !gdprConsentType || !gdprConsentVersion) {
            this.stickyGdpr.addClass('is-visible')
        } else {
            // if (typeof gtag === 'undefined') {
            //     console.warn('Cannot find gtag function – aborting setConsentType')
            //     return
            // }
            // this.setConsentType(gdprConsentType)
        }
    }

    columnClick(e) {
        const me = $(e.currentTarget)
        me.children('.modal__gdpr__radio[name=gdpr-consent]').prop('checked', true)
    }

    saveConsent() {
        const type = $('input[name=gdpr-consent]:checked').val()
        this.saveConsentCookies(type)
    }

    setConsentType(type) {
        if (type == 2) {
            // gtag('consent', 'update', {
            //     'analytics_storage': 'granted'
            // });
        } else if (type == 3) {
            // gtag('consent', 'update', {
            //     'ad_storage': 'granted',
            //     'analytics_storage': 'granted'
            // });
            // fbq('consent', 'grant');
        }
    }

    saveConsentCookies(type) {
        Cookies.set('gdprConsentAccepted', '1', {
            expires: 365,
            path: "/"
        })
        Cookies.set('gdprConsentType', type, {
            expires: 365,
            path: "/"
        })
        Cookies.set('gdprConsentVersion', this.gdprVersion, {
            expires: 365,
            path: "/"
        })
        this.stickyGdpr.removeClass('is-visible')
        this.closeModal()
        // window.location.reload(false)
    }

    closeModal() {
        $('#modal-gdpr, #modal-gdpr-container').removeClass('is-open')
        $('body').removeClass('no-scroll')
    }

    init() {
        this.checkConsent()
        this.stickyGdprAccept.on('click', () => this.saveConsentCookies(3))
        this.modalGdprColumn.on('click', (e) => this.columnClick(e))
        this.modalGdprSave.on('click', () => this.saveConsent())
        this.modalGdprAcceptAll.on('click', () => this.saveConsentCookies(3))
    }
}

$(function () {
    const moduleConsent = new Consent()
    moduleConsent.init()
})
